import { base, optimism } from 'viem/chains'

import {
  ADDRESS_ZERO,
  BASE_CBBTC_ADDRESS,
  BASE_USDT_ADDRESS,
  BASE_WBTC_ADDRESS,
  BASE_WSTETH_ADDRESS,
  CBETH_ERC20_ADDRESS,
  OPTIMISM_WBTC_ADDRESS,
  RETH_ERC20_ADDRESS,
} from '~/constants/addresses'
import { getChain, SupportedChainId } from '~/constants/chains'

import type { IAddress } from '~/types'

export const getStaticTokenLogo = (
  address: IAddress,
  chainId: SupportedChainId,
) => {
  const chainInfo = getChain(chainId)

  if (address === ADDRESS_ZERO) {
    if (!chainInfo) return undefined
    return chainInfo.nativeCurrency.logoUri
  }

  if (chainId === 1) {
    if (address === RETH_ERC20_ADDRESS) return '/tokens/mainnet/reth.svg'
    if (address === CBETH_ERC20_ADDRESS) return '/tokens/mainnet/cbeth.png'
  }

  if (chainId === optimism.id) {
    if (address === OPTIMISM_WBTC_ADDRESS) return '/tokens/wbtc.png'
  }

  if (chainId === base.id) {
    if (address === BASE_USDT_ADDRESS) return '/tokens/usdt.png'
    if (address === BASE_WBTC_ADDRESS) return '/tokens/wbtc.png'
    if (address === BASE_CBBTC_ADDRESS) return '/tokens/cbbtc.png'
    if (address === BASE_WSTETH_ADDRESS) return '/tokens/wsteth.png'
  }
}
